import RouteEnum from "constants/RouteEnum";
import React from "react";
import SottosezioneModel from "stores/contenuto/models/SottosezioneModel";
import BaseElement from "./BaseElement";

interface IProps {
    subsection: SottosezioneModel;
    background: string;
    redirectToPage: (page: RouteEnum) => void;
}
interface IState {}

class BaseSubsectionDefault extends React.Component<IProps, IState> {
    public render(): JSX.Element {
        const { subsection, background, redirectToPage } = this.props;

        return (
            <div className={background}>
                {subsection.elementi.map((element, keyelement) => (
                    <BaseElement key={keyelement} element={element} redirectToPage={redirectToPage} />
                ))}
            </div>
        );
    }
}

export { BaseSubsectionDefault as Unconnected };
export default BaseSubsectionDefault;
